import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getPublicPath } from '@/utils/paths';

/**
 * Composant SEO réutilisable pour gérer les meta tags
 * Utilise react-helmet-async pour injecter les tags dans le <head>
 */
const SEO = ({
  title = 'MN Médecine Esthétique | Clinique de Médecine Esthétique à Rouvroy',
  description = 'Une histoire de famille, de science et d\'équilibre. Clinique de médecine esthétique à Rouvroy proposant des traitements innovants : Hydrafacial, Laser Fotona, mesotherapie.',
  keywords = 'médecine esthétique, Rouvroy, Hydrafacial, laser, mesotherapie, médecine esthétique Rouvroy, clinique esthétique, soin visage, anti-âge',
  image = '/images/accueil.jpeg',
  url,
  type = 'website',
  noindex = false,
}) => {
  const publicPath = getPublicPath();
  const siteUrl = 'https://mn-medecine-esthetique.com';
  // En développement local, utiliser localhost
  const baseUrl = process.env.NODE_ENV === 'production' ? siteUrl : 'http://localhost:3000';
  const fullUrl = url ? `${baseUrl}${url}` : `${baseUrl}${publicPath || ''}${publicPath && !publicPath.endsWith('/') ? '/' : ''}`;
  const fullImageUrl = image.startsWith('http') 
    ? image 
    : `${baseUrl}${publicPath || ''}${image.startsWith('/') ? image : `/${image}`}`;

  return (
    <Helmet>
      {/* Meta tags de base */}
      <html lang="fr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content={noindex ? 'noindex,nofollow' : 'index,follow'} />
      <meta name="author" content="MN Médecine Esthétique" />
      
      {/* URL canonique */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Geo tags (localisation) */}
      <meta name="geo.region" content="FR-HDF" />
      <meta name="geo.placename" content="Rouvroy" />
      <meta name="geo.position" content="50.3947;2.9042" />
      <meta name="ICBM" content="50.3947, 2.9042" />
      
      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="MN Médecine Esthétique" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      
      {/* Additional meta tags */}
      <meta name="format-detection" content="telephone=yes" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="MN Médecine Esthétique" />
    </Helmet>
  );
};

export default SEO;

